import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import _ from 'lodash';

@Component({
    selector: 'users-demoflag-renderer',
    templateUrl: './users-demoflag-renderer.component.html',
    styleUrls: ['./users-demoflag-renderer.component.css'],
    standalone: false
})
export class UsersDemoflagRendererComponent implements ICellRendererAngularComp {

  params: any;
  icon_check!:string;
  routerLinkEditUser!:string;
  isDemoUser!:string;

  constructor() { }

  refresh(params: ICellRendererParams): boolean {
    const dataParams = params.colDef?.cellRendererParams;
    this.routerLinkEditUser = _.isFunction(dataParams.routerLinkEditUser) ? dataParams.routerLinkEditUser(params) : _.get(params.data, dataParams.routerLinkEditUser);
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;

    //console.log("=======================> RendererParams Flag = ", params);
    //this.icon_check = this.params.icon_edit || null;
    this.isDemoUser = (this.params.data)?this.params.data.isDemoUser:true;
    //console.log("=======================> isDemoUser = ", this.isDemoUser);
   
    this.routerLinkEditUser = this.params.routerLinkEditUser || null;

    // this.oauthService.userData.subscribe({
    //   next: (data) => {
    //     if (typeof data != undefined && data != null) {
    //       let userRoles = (data as any).role as Array<string>;
    //       userRoles.forEach((dbrole: string) => {
    //         if (dbrole === 'admin') {
    //           // this._db = dbrole;
    //          }
    //       });
    //     }
    //   }
    // });
    this.refresh(params);
  }



}
